import React, { useCallback, useState } from 'react';

import LanguageInfoDialog from 'bundles/unified-description-page-common/components/modules/product-overview/LanguageInfoDialog';
import LanguageInfoDialogContext from 'bundles/unified-description-page-common/contexts/LanguageInfoDialogContext';
import getLanguagesMetadata from 'bundles/unified-description-page-common/utils/getLanguagesMetadata';

export type Languages = {
  primaryLanguages: string[];
  translatedLanguages: {
    code: string;
    isMachineTranslated: boolean;
  }[];
  subtitleLanguages: string[];
  dubbedLanguages?:
    | {
        languageCode: string;
      }[]
    | null;
};

type Props = {
  languages?: Languages;
  children: React.ReactNode;
};

const LanguageInfoDialogProvider = ({ children, languages }: Props) => {
  const [isDialogOpen, setDialogOpen] = useState(false);

  const openDialog = useCallback<() => $TSFixMe>(() => setDialogOpen(true), []);
  const closeDialog = useCallback<() => $TSFixMe>(() => setDialogOpen(false), []);

  if (!languages) {
    return <>{children}</>;
  }

  const { autoTranslations, humanTranslations, subtitles, originalLanguage, dubbedLanguages } =
    getLanguagesMetadata(languages);

  return (
    <LanguageInfoDialogContext.Provider value={{ isDialogOpen, openDialog, closeDialog }}>
      {children}
      <LanguageInfoDialog
        open={isDialogOpen}
        onClose={closeDialog}
        originalLanguage={originalLanguage}
        autoTranslations={autoTranslations}
        humanTranslations={humanTranslations}
        subtitles={subtitles}
        dubbedLanguages={dubbedLanguages}
      />
    </LanguageInfoDialogContext.Provider>
  );
};

export default LanguageInfoDialogProvider;
